// extracted by mini-css-extract-plugin
export default {"container":"BootupAnimation_container__3UKRA"};